import {
  Edit,
  SimpleForm,
  TextInput,
  usePermissions,
  useNotify,
} from "react-admin";

export const RoleEdit = (props) => {
  const { permissions = [] } = usePermissions();
  const notify = useNotify();

  if (
    !(
      permissions.includes("roles.edit") ||
      permissions.includes("roles.*") ||
      permissions.includes("*")
    )
  )
    return null;

  return (
    <Edit title="Edit Role" {...props} redirect="list">
      <SimpleForm
        onSuccess={() =>
          notify("Role updated successfully", { type: "success" })
        }
      >
        <TextInput source="name" />
        <TextInput source="description" />
      </SimpleForm>
    </Edit>
  );
};